<template>
  <q-chip
    :outline="!activeFilters.includes(value)"
    :selected.sync="isSelected"
    v-bind="$attrs"
    clickable
    color="primary"
    text-color="white"
  >
    {{ label }}
  </q-chip>
</template>

<script>
export default {
  props: {
    activeFilters: Array,
    value: String,
    label: String
  },

  computed: {
    isSelected: {
      get() {
        return this.activeFilters.includes(this.value)
      },
      set(val) {
        this.$emit('filter', val)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
>>> .q-chip__icon {
  font-size 1rem
  font-weight 300
}
</style>
